export { default } from './col'
